export const sectorsConstants = {
  GETSECTORS_REQUEST: 'GETSECTORS_REQUEST',
  GETSECTORS_SUCCESS: 'GETSECTORS_SUCCESS',
  GETSECTORS_FAILURE: 'GETSECTORS_FAILURE',
};
